import { createFileRoute } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import { PlanetMark } from "@/components/planet-mark";

export const Route = createFileRoute("/unsubscribe")({
  head: () => ({
    meta: [
      { title: "Unsubscribe — Pyng" },
      { name: "description", content: "Stop receiving The Sunday Brief and other Pyng emails." },
      { property: "og:title", content: "Unsubscribe — Pyng" },
      { property: "og:description", content: "Manage the emails Pyng sends you." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: UnsubscribePage,
});

function UnsubscribePage() {
  return (
    <main className="min-h-svh flex items-center justify-center bg-background px-6 text-foreground">
      <div className="max-w-sm text-center space-y-4">
        <div className="mx-auto w-fit"><PlanetMark /></div>
        <Mail className="mx-auto h-6 w-6 text-muted-foreground" />
        <h1 className="text-xl font-semibold">Manage Pyng emails</h1>
        <p className="text-sm text-muted-foreground">
          To stop receiving emails, use the unsubscribe link at the bottom of
          any recent Pyng email. It takes effect right away.
        </p>
      </div>
    </main>
  );
}
